import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { PersonalInformationService } from './personal-information.service';
import { PersonalInformation } from './../../';
import { businessValidator } from './../../directives/business-validator.directive';
import { Status } from './../../enums/status';

@Component({
  selector: 'personal-information',
  template: require('./personal-information.component.html'),
  styles: [require('./personal-information.component.scss')],
  providers: [PersonalInformationService]
})
export class PersonalInformationComponent implements OnInit {
  @Output() onSave = new EventEmitter();

  public Status = Status;
  status: Status;
  infoForm: FormGroup;

  get firstName() { return this.infoForm.get('firstName'); }
  get lastName() { return this.infoForm.get('lastName'); }
  get company() { return this.infoForm.get('company'); }
  get position() { return this.infoForm.get('position'); }

  get business() { return this.infoForm.get('business'); }
  get businessChoice() { return this.infoForm.get('business.businessChoice'); }
  get other() { return this.infoForm.get('business.other'); }

  get city() { return this.infoForm.get('city'); }
  get country() { return this.infoForm.get('country'); }
  get subscribe() { return this.infoForm.get('subscribe'); };

  constructor(private fb: FormBuilder, private service: PersonalInformationService, private route: ActivatedRoute, private router: Router) {
  }

  ngOnInit() {
    this.createForm();

    this.status = Status.Loading;
    this.service.getPersonalInformation()
      .then(this.setInformation.bind(this))
      .catch((err) => {
        this.status = Status.Error;
      });
  }

  setInformation(info: PersonalInformation) {
    if (info !== null && info !== undefined) {
      let index = this.service.businessChoices.indexOf(info.business);
      let businessChoice = info.business;
      let other = '';
  
      if (index > -1) {
        this.service.businessChoice = this.service.businessChoices[index];
      } else {
        businessChoice = 'Other';
        other = info.business;
      }
  
      this.infoForm.patchValue({
        firstName: info.firstName,
        lastName: info.lastName,
        company: info.company,
        position: info.position,
        business: {
          businessChoice: businessChoice,
          other: other
        },
        city: info.city,
        country: info.country
      });
    }

    this.status = Status.Loaded;
  }

  createForm() {
    this.infoForm = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(128)]],
      lastName: ['', [Validators.required, Validators.maxLength(128)]],
      company: ['', [Validators.required, Validators.maxLength(128)]],
      position: ['', [Validators.required, Validators.maxLength(128)]],
      business: this.fb.group({
        businessChoice: 'Select a Business',
        other: ''
      }, { validator: businessValidator }),
      city: ['', [Validators.required, Validators.maxLength(128)]],
      country: ['', [Validators.required, Validators.maxLength(128)]],
      subscribe: ['', Validators.required]
    });

    // switch businessChoice to an enum when typescript version is updated past 2.4
  }

  save() {
    this.touchAllFormElements();

    if (this.infoForm.invalid || this.status === Status.Loading || this.status === Status.Sending) {
      return;
    }
    this.status = Status.Sending;

    let model = this.preparePersonalInformationModel();

    this.service.save(model).then((response) => {
      this.status = Status.Success;
      this.onSave.emit();
    }).catch((err) => {
      this.status = Status.Error;
    });
  }

  touchAllFormElements() {
    for (let control in this.infoForm.controls) {
      this.infoForm.controls[control].markAsTouched();
    }
  }

  preparePersonalInformationModel(): PersonalInformation {
    const form = this.infoForm.value;

    let business = form.business.businessChoice === 'Other' ? form.business.other : form.business.businessChoice;

    let information = {
      firstName: form.firstName as string,
      lastName: form.lastName as string,
      business: business,
      company: form.company as string,
      position: form.position as string,
      country: form.country as string,
      city: form.city as string,
      subscribe: form.subscribe as boolean,
    };

    return new PersonalInformation(information);
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/shared/components/personal-information/personal-information.component.ts